/**
 * @description 欢迎礼包
 */

import { RewardStatusEnum, RewardTypeEnum } from "@/types/reward";
import { RewardIcon } from "./reward-icon";
import { Button } from "@/components/ui/button";
import { showWalletModal } from "@/features/wallet";
import { useTranslations } from "next-intl";

interface WelcomeRewardProps {
  id: number;
  status: RewardStatusEnum;
  // 加成百分比
  bonusPercentage?: number;
  onDeposit?: () => void;
}

export const WelcomeReward = (props: WelcomeRewardProps) => {
  const { id, status, bonusPercentage, onDeposit } = props;
  const t = useTranslations('reward');
  const tPromotions = useTranslations('promotions');
  if (status !== RewardStatusEnum.DEPOSIT) {
    return null;
  }

  const handleDeposit = () => {
    showWalletModal({
      entrance: 'root',
      customTitle: tPromotions('selectRechargeMethod'),
      hideWithdraw: true,
      customParams: {
        track_source: 'Welcome Bonus',
        gift_id: id,
      },
    });
    onDeposit?.();
  };

  return (
    <div className="bg-dark-special rounded-lg py-4 pr-3" style={{ background: 'linear-gradient(to bottom right, #1D3657 0%, #1B2131 65%, #1B2131 100%)', }}>
      <div className="flex items-center justify-between">
        <RewardIcon type={RewardTypeEnum.WELCOME_GIFT} className="mr-2.5" />
        <div className="flex-1">
          <div className="flex items-center">
            <div className="text-white text-ss font-medium leading-3">{t('maxUpTo', { amount: `${bonusPercentage}%` })}</div>
          </div>
          <div className="text-tertiary text-ss font-medium leading-3 mt-3">{t('welcomeGift')}</div>
        </div>
        <Button
          variant="warning"
          className="w-[90px] h-8 ml-[10px]"
          onClick={handleDeposit}>
          {t('recharge')}
        </Button>
      </div>
    </div>
  );
};